export const SCREEN_2_VERSION = '2.*';
export const DEFAULT_SCREEN_VERSION = '0.*';